import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { IUseHardwareFilter } from '../../../ts/interface/hardware.interface';
import { getRentalRoute } from '../../../api/rentals';

interface Parameters {
  queryParameters?: IUseHardwareFilter;
  paginationResultHandler?: Function;
  systemId?: string;
}

const useRentalRoute = (
  rentalId: string,
  options?: Omit<UseQueryOptions, 'queryKey' | 'queryFn'>,
  parameters?: Parameters
) => {
  return useQuery({
    queryKey: ['rentalRoute', parameters?.queryParameters, rentalId],
    queryFn: () =>
      getRentalRoute(
        rentalId,
        parameters?.queryParameters,
        parameters?.paginationResultHandler
      ),
    ...options,
  });
};

export default useRentalRoute;
